var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isWaiting)?_c('div',{staticClass:"wait"},[_vm._t("waiting")],2):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }